import { render, staticRenderFns } from "./save-checklist-template.vue?vue&type=template&id=5160ccec&scoped=true"
import script from "./save-checklist-template.vue?vue&type=script&lang=js"
export * from "./save-checklist-template.vue?vue&type=script&lang=js"
import style0 from "./save-checklist-template.vue?vue&type=style&index=0&id=5160ccec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160ccec",
  null
  
)

export default component.exports